import React from "react";

const UserOverviewLabelValue = ({ label, value }) => {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-between border-bottom mb-1 px-1">
        <div>{label}</div>
        <div>{value ?? "No Data"}</div>
      </div>
    </React.Fragment>
  );
};

export default UserOverviewLabelValue;
